<router-outlet></router-outlet>
<!-- <ng-content *ngIf = "! (isLoading | async); else indicator"> </ng-content>  -->
<ng-content *ngIf="!isLoading; else indicator"> </ng-content>
<!-- <livechat-widget license="12317217" *ngIf="!isRouterUrlSignupSimplify">LiveChat</livechat-widget> -->
<div (touchend)="onFabSwiper($event)" (touchstart)="onFabSwiper($event)">
  <div class="fab-wrap" [class.show]="!isFab" *ngIf="this.userDeviceInfo === 'mobile'">
    <div class="fab-button">
      <div class="fab-icon" (click)="onClickCS()">
        <img src="/assets/images/{{ csFabSrc }}.svg" alt="" />
      </div>
      <div
        class="fab-icon"
        (click)="onClickBulkProducts()"
        [class.disabled]="
          productService.selectProducts.length === 0 ||
          ['/cart', '/order', '/order/select-gift', '/order/payment', '/order/complete'].includes(this.location.path())
        "
      >
        <img src="/assets/images/bag-outline.svg" alt="" />
        <!-- <div class="count">
          {{ productService.selectProducts.length }}
        </div> -->
      </div>
      <div id="isShowHide" (click)="onFabPopup()" [class.show]="isLiveChat">
        <img src="/assets/images/chevron-forward-outline.svg" *ngIf="isFab" alt="" />
        <img src="/assets/images/chevron-back-outline.svg" *ngIf="!isFab" alt="" />
      </div>
    </div>
  </div>
</div>
<ng-template #indicator>
  <div class="indicator">
    <div>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</ng-template>
